import { mapIgError } from './igError';

/** Итог «Дублировать в сторис» по аккаунту — так его отдают бэкенд и edge-функция. */
export interface StoryOutcome {
  status: 'success' | 'error';
  error?: string;
}

/**
 * Сторис, которые не вышли, одной строкой для тоста: «@a — причина; @b — причина».
 * Пост или рилс при этом уже в ленте, поэтому это предупреждение, а не ошибка.
 * null — сторис не просили или все вышли.
 */
export function describeStoryFailures(items: { name: string; story?: StoryOutcome | null }[]): string | null {
  const failed = items.filter((i) => i.story?.status === 'error');
  if (failed.length === 0) return null;
  return failed.map((i) => `@${i.name} — ${mapIgError(i.story?.error).friendly}`).join('; ');
}
